var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13283_8939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69922 12.9992C1.69922 12.2812 2.28125 11.6992 2.99922 11.6992H22.9992C23.7172 11.6992 24.2992 12.2812 24.2992 12.9992C24.2992 13.7172 23.7172 14.2992 22.9992 14.2992H2.99922C2.28125 14.2992 1.69922 13.7172 1.69922 12.9992Z",
    fill: "#563DDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13283_8939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.8c587d6956f648b6720ad7e1818cea1a.svg";
export { ForwardRef as ReactComponent };